import * as TYPES from '../types';

export const addAnnouncementAction = (payload) => {
    return {
        type: TYPES.ADD_ANNOUNCEMENT,
        payload: payload
    };
};

export const getAllAnnouncementAction = () => {
    return {
        type: TYPES.GET_ALL_ANNOUNCEMENT,
    };
};

export const getAllAnnouncementActionSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_ANNOUNCEMENT_SUCCESS,
        payload: payload
    };
};

export const editAnnouncementAction = (payload) => {
    return {
        type: TYPES.EDIT_ANNOUNCEMENT,
        payload: payload
    };
};

export const deleteAnnouncementAction = (payload) => {
    return {
        type: TYPES.DELETE_ANNOUNCEMENT,
        payload: payload
    };
};

export const updateAnnouncementStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_ANNOUNCEMENT_STATUS,
        payload: payload
    };
};
